/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class MenuPopup extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);

    const dark = this.scene.add.rectangle(-285.5, -130, 571, 260, 0xa6a6a6, 1).setOrigin(0);
    this.add(dark);

    const localeAdj = ABCyaLib.Environment.instance.locale === 'es-US' ? -8 : 0;
    this.dialogBitmap = ABCyaPhaser.Images.addImage(0, localeAdj, 'menu_dialog', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);

    this.saveBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'save_button', null, () => {
      this.toggleBtns(false);

      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.emit('SAVE_CLICKED');
    }, this, { disabledTint: 0xFFFFFF });

    this.printBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'print_button', null, () => {
      this.toggleBtns(false);

      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.emit('PRINT_CLICKED');
    }, this, { disabledTint: 0xFFFFFF });

    this.newBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'new_button', null, () => {
      this.toggleBtns(false);

      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.emit('RESET_CLICKED');
    }, this, { disabledTint: 0xFFFFFF });

    this.exitBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'cancel_button', null, () => {
      this.toggleBtns(false);

      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.emit('EXIT_CLICKED');
    }, this, { disabledTint: 0xFFFFFF });

    this.buttons = [this.saveBtn, this.printBtn, this.newBtn, this.exitBtn];

    let count = 0;
    this.buttons.forEach((button) => {
      button.y = button.getBounds().width / 4;
      button.x = (count * (button.getBounds().width + 25)) - 145;
      count++;
    });
  }

  toggleBtns(toggle) {
    this.buttons.forEach((btn) => {
      btn.setEnabled(toggle);
    });
  }
}